var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h3',{staticClass:"free-title"},[_c('span',[_vm._v(_vm._s(_vm.title || '订阅专栏'))]),(!_vm.full)?_c('i',[_vm._v("查看往期 >")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }